import ApiService from "./ApiService"

class AuthService extends ApiService {
    localStorageItem = 'at';
    urlCheck = '/auth/check';
    urlLogin = '/auth/login';
    urlLogout = '/auth/logout';


    check(token) {
        this.setAuth(token);
        return this.postResource(this.urlCheck);
    }

    login(credentials) {
        return this.postResource(this.urlLogin, credentials);
    }

    logout() {
        this.enableAuth();

        return this.postResource(this.urlLogout);
    }

    lsToken() {
        return localStorage.getItem(this.localStorageItem);
    }

    getAuthHeader() {
        return {
            'X-Authorization': this.lsToken()
        }
    }
}

export {
    AuthService
}

export default new AuthService();
